import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';
import Icon from 'Components/Atoms/Icon/Icon';

export default function AlertForm({ children, onClose, className }) {
    return (
        <div role="alert" className={cn('relative bg-danger/10 rounded-md py-3 px-3 pr-10', className)}>
            <div className="flex items-start gap-2">
                <div className="shrink-0 mt-0.5">
                    <Icon name="circle-alert" size={20} color="currentColor" className="text-danger" />
                </div>
                <div className="text-sm text-dark-blue">{children}</div>
            </div>
            {onClose && (
                <button
                    type="button"
                    onClick={onClose}
                    className="absolute top-2.5 right-2.5 text-dark-blue/50 hover:text-dark-blue transition-colors"
                >
                    <Icon name="close" size={16} color="currentColor" />
                </button>
            )}
        </div>
    );
}

AlertForm.propTypes = {
    children: PropTypes.node.isRequired,
    onClose: PropTypes.func,
    className: PropTypes.string,
};
